import Helpers from '@Apis/helpers';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { DEFAULT_CUR_ROUND_OFF, QUANTITY } from '@Apis/constants';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import { notification } from 'antd';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import GrnErrors from './grnErrors';

export const INITIAL_STATE = () => {
  return {
    grnDate: dayjs(),
    deliveryDate: dayjs(),
    toggleRejectedBatches: false,
    grnTableData: [],
    isUserReadyForCreate: false,
    grnOriginalData: [],
    totalBatchWiseQty: 0,
    handleFullQuantity: false,
    selectedLineId: '',
  }
}

export function customInputChangeHelper(state, props, fieldValue, cfId, setState) {
  const { cfGoodReceivingNotesDoc } = state;
  const newCustomField = cfGoodReceivingNotesDoc?.map((customField) => {
    if (customField?.cfId === cfId) {
      if (customField?.fieldType === 'ATTACHMENT') {
        return {
          ...customField,
          fieldValue: fieldValue?.map((attachment) => ({
            url: attachment?.response?.response?.location || attachment?.url,
            type: attachment?.type,
            name: attachment?.name,
            uid: attachment?.uid,
          })),
        };
      }
      return {
        ...customField,
        fieldValue,
      };
    }
    return {
      ...customField,
    };
  });
  setState({
    cfGoodReceivingNotesDoc: newCustomField,
  });
}

const isGrnValid = (grnData) => {
  let isValid = true;
  for (let i = 0; i < grnData?.length; i++) {
    const item = grnData[i];
    const sourceBatches = item?.source_product_batches;
    for (let j = 0; j < sourceBatches?.length; j++) {
      const batch = sourceBatches[j];
      const batchWiseQty = Number(batch?.batch_wise_quantity || 0);
      const availableQty = Number(batch?.available_qty || 0);
      const batchCreatedQty = Number(batch?.batch_created_qty || 0);
      if (batchWiseQty < 0 || batchWiseQty > (availableQty - batchCreatedQty)) {
        isValid = false;
        break;
      }
    }
    if (!isValid) {
      break;
    }
  }
  return isValid;
}

export const handleFullQuantityHelper = (state, item, setState) => {
  const { grnTableData } = state;
  const copyData = JSON.parse(JSON.stringify(grnTableData));
  const updatedData = copyData.map((obj) => {
    if (obj.parent_key === item.parent_key) {
      return { ...obj, batch_wise_quantity: QUANTITY(((obj?.quantity || 0) - (obj?.batch_created_qty || 0)), obj?.uom_info?.precision) };
    }
    return obj;
  });
  setState({
    grnTableData: updatedData,
  })
}

export const handleCreateGRNHelper = (state, props, approve, updateGRN, setState) => {
  const { grnTableData, selectedPoForGrn, terms, grnDate, fileList, deliveryDate, invoiceNumber, cfGoodReceivingNotesDoc, grnOriginalData, formSubmitted, grnNumber, docSeqId, initialGrnNumber } = state;
  const { addGRN, selectedSt, callback, stockTransferType, history, grnData } = props;
  if (approve) {
    setState({ buttonClick: 'ISSUED', formSubmitted: true });
  }
  else {
    setState({ buttonClick: 'DRAFT', formSubmitted: true });
  }
  const finalData = updateSourceProductBatchesHelper(grnOriginalData, reverseTransformDataHelper(grnTableData));
  const stType = stockTransferType === 'Internal' ? 'good_receiving_note_internal_stock_transfer' : 'good_receiving_note_external_stock_transfer';

  // checking if batch_wise_quantity is undefined or null
  const authQty = finalData?.map((item) => item?.source_product_batches?.map((batch) => batch?.batch_wise_quantity)).flat().filter((i) => i !== undefined && i !== null).length;

  // errors from error component
  const { docLevelError, lineLevelError } = GrnErrors({ grnDate, deliveryDate, cfGoodReceivingNotesDoc, grnTableData, grnNumber });

  if (authQty === 0) {
    notification.error({
      message: 'Please fill at least one line of receiving quantity for creating GRN',
      placement: 'top',
      duration: 4,
    });
  }
  if ((docLevelError?.length == 0 && lineLevelError?.length == 0) && isGrnValid(finalData) && authQty > 0 && grnDate && deliveryDate && !cfGoodReceivingNotesDoc?.filter((customField) => customField.isActive && customField?.isRequired && (customField?.fieldType === 'ATTACHMENT' ? !customField?.fieldValue?.length : !customField?.fieldValue))?.length) {
    if (selectedSt) {
      const grnLines = finalData?.map(
        (item) => ({
          grn_entity_line_id: item?.stock_transfer_line_id || '',
          tenant_product_id: item?.destination_tenant_product_id || '',
          // here updated quantity adding batch_wise_quantity
          quantity: item?.source_product_batches?.reduce((acc, batch) => acc + Number(batch?.batch_wise_quantity || 0), 0) || 0,
          secondary_uom_qty: item?.secondary_uom_qty || 0,
          offer_price: Number(item.offer_price) || 0,
          tax_id: Number(item?.product_sku_info?.tax_info?.tax_id),
          tax_group_info: item?.product_sku_info?.tax_info,
          expiry_date: dayjs(item.expiry_date).format('YYYY-MM-DD'),
          uom_id: item?.uom_info?.uom_id,
          uom_info: [item?.uom_info],
          remarks: item?.remarks,
          product_batches: item?.source_product_batches
            ?.filter((i) => typeof i?.batch_wise_quantity !== 'undefined' && i?.batch_wise_quantity !== null && i?.batch_wise_quantity !== 0 && i.batch_wise_quantity !== '0' && i.batch_wise_quantity !== '')
            .map((i) => ({
              ...i,
              quantity: i?.batch_wise_quantity || 0,
              tenant_product_id: item?.destination_tenant_product_id,
              tenant_department_id: selectedSt?.destination_tenant_department_id,
              uom_id: item?.uom_info?.uom_id,
            })),
        }),
      );
      const filteredGrnLines = grnLines?.filter((grnLine) => grnLine?.product_batches && grnLine?.product_batches.length > 0);

      const payload = {
        grn_lines: filteredGrnLines,
        tenant_department_id: selectedSt?.destination_tenant_department_id,
        grn_entity_id: selectedSt?.stock_transfer_id,
        grn_date_time: grnDate,
        invoice_number: invoiceNumber,
        invoice_date: deliveryDate,
        grn_entity_type: 'INVENTORY_TRANSFER',
        operation: stType,
        tenant_seller_info: selectedPoForGrn?.tenant_seller_info,
        grn_tenant_id: selectedSt?.destination_department_info?.tenant_id,
        remark: terms,
        attachments: fileList?.map((attachment) => ({
          url: attachment?.response?.response?.location || attachment?.url, type: attachment?.type, name: attachment?.name, uid: attachment?.uid,
        })) || [],
        status: approve ? 'ISSUED' : 'DRAFT',
        custom_fields: cfGoodReceivingNotesDoc?.length ? cfGoodReceivingNotesDoc?.map((customField) => ({
          cf_id: customField?.cfId,
          field_name: customField?.fieldName,
          field_value: customField?.fieldValue,
          field_type: customField?.fieldType,
          is_required: customField?.isRequired,
          is_active: customField?.isActive,
          default_data: customField?.defaultData,
          placeholder: customField?.placeholder,
        })) : [],
        grn_number: initialGrnNumber?.toLowerCase()?.trim() === grnNumber?.toLowerCase()?.trim() ? null : grnNumber,
        seq_id: docSeqId || null,
      };
      addGRN(payload, () => {
        callback();
        setState({
          formSubmitted: false,
        })
      });
    } else {
      const tempGrnData = grnData?.grn?.[0];
      const grnLines = finalData?.map(
        (item) => ({
          grn_entity_line_id: item.grn_entity_line_id || '',
          tenant_product_id: item.product_sku_info.tenant_product_id || '',
          quantity: item?.source_product_batches?.reduce((acc, batch) => acc + Number(batch?.batch_wise_quantity || 0), 0) || 0,
          secondary_uom_qty: item?.secondary_uom_qty || 0,
          offer_price: Number(item.offer_price) || 0,
          tax_id: Number(item?.tax_info?.tax_id),
          tax_group_info: item?.tax_info,
          remarks: item?.remarks,
          expiry_date: item.expiry_date,
          uom_id: item?.uom_info?.uom_id,
          uom_info: [item?.uom_info],
          product_batches: item?.source_product_batches
            ?.filter((i) => typeof i.batch_wise_quantity !== 'undefined' && i.batch_wise_quantity !== null && i.batch_wise_quantity !== 0 && i.batch_wise_quantity !== '')
            .map((i) => ({
              ...i,
              quantity: i?.batch_wise_quantity || 0,
              tenant_product_id: item?.destination_tenant_product_id,
              tenant_department_id: tempGrnData?.tenant_department_id,
              uom_id: item?.uom_info?.uom_id,
            })),
        }),
      );
      const payload = {
        grn_lines: grnLines,
        operation: stType,
        grn_entity_id: tempGrnData?.grn_entity_id,
        tenant_seller_info: grnTableData?.tenant_seller_info,
        grn_tenant_id: tempGrnData?.grn_tenant_id,
        grn_id: tempGrnData?.grn_id,
        status: approve ? 'ISSUED' : 'DRAFT',
        grn_date_time: grnDate,
        invoice_number: invoiceNumber,
        invoice_date: deliveryDate || null,
        grn_entity_type: 'INVENTORY_TRANSFER',
        remark: terms || '',
        attachments: fileList?.map((attachment) => ({
          url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment?.name, uid: attachment?.uid,
        })) || [],
        custom_fields: cfGoodReceivingNotesDoc?.map((customField) => ({
          cf_id: customField?.cfId,
          field_name: customField?.fieldName,
          field_value: customField?.fieldValue,
          field_type: customField?.fieldType,
          is_required: customField?.isRequired,
          is_active: customField?.isActive,
          default_data: customField?.defaultData,
          placeholder: customField?.placeholder,
        })),
        grn_number: initialGrnNumber?.toLowerCase()?.trim() === grnNumber?.toLowerCase()?.trim() ? null : grnNumber,
      };
      updateGRN(payload, () => {
        ({ formSubmitted: false });
        history.push(`/purchase/goods-receiving/view/${tempGrnData?.grn_id}/type=st`);
      });
    }
  }
}

export const getAvailableBatchesHelper = (grnLine) => {
  if (grnLine?.product_batches?.[0]?.batch_id) {
    return grnLine?.available_batches || [];
  }
  if (grnLine?.available_batches) {
    return [...grnLine?.product_batches, ...grnLine?.available_batches];
  }
  return [...grnLine?.product_batches];
};

export const handleDeleteHelper = (state, key, setState) => {
  const { grnTableData, grnOriginalData } = state;
  const copyData = JSON.parse(JSON.stringify(grnTableData));
  const updatedData = copyData.filter((obj) => obj.parent_key !== key);
  const updatedGrnOriginalData = grnOriginalData.filter((obj) => obj.key !== key);
  if (updatedData.length < 1) {
    notification.error({
      message: 'At least one line item is required to create GRN',
      placement: 'top',
      duration: 4,
    });
  } else {
    const updatedSqNo = updatedData.map((item, i) => (item.skuId ? { ...item, sq_no: i > 0 ? i : i + 1 } : item));
    setState({
      grnTableData: updatedSqNo,
      grnOriginalData: updatedGrnOriginalData,
    });
  }
}

export const updateSourceProductBatchesHelper = (originalData, updatedData) => {
  // Iterate through updatedData
  updatedData.forEach((updatedItem) => {
    // Find the corresponding item in originalData
    const originalItem = originalData.find((item) => item?.key === updatedItem.parent_key);

    if (originalItem) {
      // Update source_product_batches for the found item
      originalItem.source_product_batches = updatedItem.source_product_batches;
      originalItem.remarks = updatedItem.remarks;
      originalItem.secondary_uom_qty = Number(updatedItem.secondary_uom_qty);
    }
  });
  return originalData;
}

export const reverseTransformDataHelper = (inputArray) => {
  const result = [];

  // Group the items by parent_key
  const groupedItems = inputArray?.reduce((groups, item) => {
    const {
      parent_key, available_qty, expiryDays, uom_info, ...rest
    } = item;

    if (!groups[parent_key]) {
      groups[parent_key] = {
        product_sku_info: { ...rest },
        source_product_batches: [],
      };
    }

    // Add the batch information
    if (item.batch_id !== undefined) {
      groups[parent_key].source_product_batches.push({
        ...item,
        quantity: available_qty,
        expiryDays,
        uom_info,
      });
    }

    return groups;
  }, {});

  // Convert the grouped items to the original format
  for (const key in groupedItems) {
    const item = groupedItems[key];
    result.push({
      ...item?.product_sku_info,
      source_product_batches: item?.source_product_batches,
      parent_key: key,
    });
  }

  return result;
}

export const transformDataHelper = (inputArray) => {
  return inputArray?.reduce((result, item) => {
    const { product_sku_info, source_product_batches } = item;
    // Create a new object for product_sku_info
    const productInfoObj = {
      ...product_sku_info,
      key: uuidv4(),
      skuId: product_sku_info?.product_sku_id,
      quantity: item?.quantity,
      sq_no: item?.sq_no,
      parent_key: item?.key,
      consumed_qty: item?.consumed_qty,
      remarks: item?.remarks,
      secondary_uom_qty: item?.secondary_uom_qty,
    };
    result.push(productInfoObj);

    // Create a new object for each available batch related to the product
    source_product_batches?.forEach((batch) => {
      const batchObj = {
        key: uuidv4(),
        ...batch,
        uom_info: item?.uom_info,
        parent_key: item?.key,
        available_qty: batch?.quantity,
        batch_wise_quantity: !item?.grn_id ? batch?.batch_wise_quantity : batch?.quantity,
        expiryDays: item?.expiryDays,
        secondary_uom_info: product_sku_info?.secondary_uom_info,
      };
      result.push(batchObj);
    });

    return result;
  }, []);
}